/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { isAbortXhr } from '@hb/sharp-request';
import { session } from '@/shared/utils/storage';
import IdenttityScoreMixins from '@/mixins/finance-identity';
import PreApplyChooseAPI, { reportUserStayStatus } from '@/api/preApplyChoose';
import { livenessPop } from '@/components/liveness-pop';
import RouterHelper from '@/shared/utils/routerHelper';
import { Loading } from '@/shared/utils/loading';
import { Toast, Dialog } from '@hb/coffee';
import { RouterH5Enum, RouterV2Enum } from '@/router/router-names';
import store from '@/store';
import './store';
import '@/views_v2/home/store';
import platform from '@/shared/utils/platform';
import { setPageTitle } from '@/api/native/utils';
import { getDeviceRiskData } from '@/shared/tools/startLiveness/utils';
import { UserInfoCompleteMixins } from '@/mixins/info-complete';
import preApplyResult, { USER_HAS_JUMPED_OUT_PAGE_KEY } from '@/mixins/preApply';
import { LivenessProjectEnum, LivenessSceneEnum } from '@/enums/liveness-param';
import AbTest from '@/mixins/abTest';
import { UpgradeStateEnum } from '@/enums/autarkyUpgrade';
import { upgradeUserInfosKey } from '@/constant/user';
import { Route } from 'vue-router';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import FinanceBusiness from '@/mixins/finance-business';
import { UserInfoStatus } from '@/enums/UserInfoStatus';
import jumpToVerifyCredit, { checkVerifyCreditCompleteByScene as isVerifyCreditComplete } from '@/shared/verify-credit-controller';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import UserPersonalInfoApi from '@/api/userPersonalInfo';
import { ubtSendError } from '@/shared/utils/ubt';
import { getGalileoAb } from '@/shared/galileoAb';
import { ABResEnum } from '@/enums/abExperiment';
import {
  commodityModelItemType, UserStayStatusSceneEnum, dcCreditSceneEnum,
  PrefilterDispatchTypeEnum, CreditTaskStatusEnum,
  CreditApplyTaskType,
} from '@/api/preApplyChoose/types';
import { queryContractList } from '@/api/rights/shop-mall';
import type { ProductItemType, QueryContractListResponse } from '@/api/rights/shop-mall/types';
import {
  CreditMallContractSceneEnum,
  CreditMallFromEnum,
} from '@/api/rights/shop-mall/types';

import { Debounce } from '@/shared/decorators/debounce';
import type { VueConstructor } from 'vue';
import { allSettledPolyfill } from '@/shared/tools/ocr/utils/polyfill';
import { miniProgramBackPreviousPage } from '@/api/native/wechat';
import { dialogHelper } from '@/shared/utils/dialogHelper';
import { PopupIdEnum, PopupRelatedStatusEnum } from '@/api/popup/types';
import { queryPopupFatigue } from '@/api/popup';
import { creditAgreementsReadPop } from '@/components/credit-agreements-read-pop';
import { chooseNoChannelRouter, checkAndHandleLocationPermission, getMiddleIncomeLink } from './utils';
import { handleFqMallReviewFlow } from './fq-mall-utils';
import ConsentAgreement from './consent-agreement/index.vue';
import LoadingBackPop from './components/loading-back-pop/index.vue';
import ContractBackPop from './components/contract-back-pop/index.vue';
import ProfessionPicker from './components/profession-select';
import type { ApplyChooseList } from './types';
import { ApplyModeEnum } from './types';
import LoadingAnimate from './components/loading-animate/index.vue';
import UnitAgreement from './unit-agreement/index.vue';

import './credit.theme.blue.scss';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LoadingAnimateComp = LoadingAnimate as any;

const style = require('./index.module.scss') as Dictionary;

const PreApplyChooseStore = namespace('preApplyChoose');
const HomeStore = namespace('home');

allSettledPolyfill();

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);
@Component({ name: 'PreApplyChoose' })
export default class PreApplyChoose extends Mixins(
  IdenttityScoreMixins,
  UserInfoCompleteMixins,
  preApplyResult,
  AbTest,
  FinanceBusiness,
) {
  /** 是否纯贷超半流程 */
  @Prop({
    type: Boolean,
    required: false,
  })
  readonly isDcPreApplyChoose!: boolean;

  /** 来源 */
  @Prop({
    type: String,
    required: false,
  })
  readonly from!: string;

  /** 是否纯贷超半流程场景，不展示分期商城、超会、车抵贷逻辑 */
  @Prop({
    type: Boolean,
    required: false,
  })
  readonly isOnlyDcHalf!: boolean;

  @PreApplyChooseStore.State newAgreementChannels!: number[];

  @PreApplyChooseStore.State applyChooseList!: ApplyChooseList | null;

  @PreApplyChooseStore.State isDcHalfApply!:boolean;

  @PreApplyChooseStore.State creditRouteChannel!: string;

  @PreApplyChooseStore.State submitCommodityIds!: number[];

  @PreApplyChooseStore.State commodityModelList!: commodityModelItemType[];

  @HomeStore.Action getCreditData!: (shouldRefresh?: boolean) => Promise<void>;

  @HomeStore.Action getUserAutarkyState!: () => Promise<boolean>;

  @PreApplyChooseStore.Action $resetState!: () => void;

  private get myProfileChoose() {
    return session.get('myProfile') || '';
  }

  private get dcCreditScene() {
    return this.isDcPreApplyChoose
      ? dcCreditSceneEnum.PURE_DC : dcCreditSceneEnum.NO_CHANNEL_AVAILABLE;
  }

  /** 显示loading页 */
  private showLoading = true;

  /** 挽回弹窗是否展示 */
  private showBackPop = false;

  /** 当前backPop展示相关状态 */
  private backPopRelatedStatus: PopupRelatedStatusEnum = PopupRelatedStatusEnum.INIT;

  /** 用户查看协议的初始时间节点 */
  private userViewAgreementStartTime = 0;

  /** 是否分发渠道分发中，在活体认证成功后，设置标识为true，防止小程序在活体Pop无效消耗广告弹窗疲劳度 */
  private isRealInLoadCommodityDispatch = false;

  /** 当前页面名称，用于弹窗管理相关(触发退出挽留弹窗时,location.hash可能会变化) */
  private currentPageName = '';

  private canShowContactList = true;

  /** 轮询授信结果的任务定时器 */
  private creditTaskResultTimer: NodeJS.Timeout | null = null;

  private setUserViewAgreementStartTime(value: number) {
    this.userViewAgreementStartTime = value;
  }

  private get ocrAfterLoan() {
    return !!store.state.base.businessInfoExtra?.userInfo?.ocrAfterLoan;
  }

  private get businessInfoextraData() {
    return store.state.base.businessInfoExtra?.userInfo?.extraData;
  }

  /** 分期商城协议列表 */
  private fqMallContractList: QueryContractListResponse | undefined = undefined;

  /** 是否新授信分期商城 */
  private showCreditFqmall = false;

  /** 分期商城分期产品列表 */
  private fqProductList: ProductItemType[] = [];

  /**
   * 正常授信(联营导流)流程活体前置校验逻辑
  */
  private async livePreValidation() {
    await this.getUserAutarkyState();

    if (!this.canApplyCredit) {
      this.$ubtPageButton('finance_loan_credit_noApplyCreditDialog');
      // 增加自营用户再次授信拦截
      Dialog.alert({
        title: '操作失败',
        message: '无新渠道可申请',
        confirmButtonText: '确认',
        closeable: false,
      }).then(() => {
        // 无渠道可申请时，需要去除挽留弹窗逻辑
        RouterHelper.setBackConfirm(false);
        RouterHelper.backHome();
      });
      return;
    }

    if (!this.confirmShouldIdentityScore()) return;
    this.getPreApplyInfo();
  }

  private async created() {
    // 调用 $resetState 方法重置状态，确保页面渲染时使用的是最新的数据
    this.$resetState();
    /** 清除页面的弹窗状态 */
    dialogHelper.resetPageDialogStatus(
      this.currentPageName = window.location.hash,
    );
    /** 小程序场景，先初始化退出挽留的事件记录 */
    this.oncePushStateForMpBackPopup();

    await Promise.all([
      /** 获取用户升级信息 */
      this.getCreditData(),
    ]);

    if (!this.isDcPreApplyChoose) {
      /** 非纯半流程授信逻辑 */
      this.livePreValidation();
    } else {
      /** 纯半流程授信逻辑 */
      this.getPeApplyChooseList(false);
    }
    /** 绑定this重新生成函数，便于后续事件监听删除 */
    this.listenForceBackHomeFromCreditResult = this.listenForceBackHomeFromCreditResult.bind(this);
  }

  // 返回时，触发埋点, 上报用户返回上层页面埋点
  private async beforeRouteLeave(
    to: Route,
    from: Route,
    next: (...d: unknown[]) => void,
  ) {
    // 清除授信任务结果轮询定时器
    this.clearCreditTaskResultTimer();
    // 是否返回操作,此处用isBack半流程回退跳转贷超逻辑会循环处理回退逻辑，页面报错
    const isBack = RouterHelper.isBackOnce();

    /** 离开当前页面 */
    const doLeave = () => {
      const { preCreditDelayTime = 30 } = this.applyChooseList || {};
      const realViewAgreementTime = Date.now() - this.userViewAgreementStartTime;

      /** 若是离开到非授信结果页，且查看渠道协议时长不达标，则需要上报服务端 */
      if (this.userViewAgreementStartTime
        && realViewAgreementTime <= preCreditDelayTime * 1000
        && !this.userHasJumpedCreditResult
      ) {
        /** 服务端会过滤8180非首位的用户，所以前端不考虑 8180非首位-用户 点击“同意协议提交”可能到 进入资料页的情况 */
        this.doReportUserStayStatus(UserStayStatusSceneEnum.MIDWAY_LEAVE);
      }

      next();
    };

    if (isBack) {
      // 记录页面按钮行为
      this.$ubtPageButton('finance_creditAgreementBack');

      // 分期商城的场景直接退出页面，不走挽留逻辑
      if (this.showCreditFqmall) {
        next();
      } else {
        // 非贷超半流程 或 （贷超半流程 & 用户未提交授信[跳结果页]）
        if (!this.isDcHalfApply || !this.userHasJumpedCreditResult) {
          /** 若用户已选择离开，则直接退出，不进行疲劳度查询 */
          if (this.backPopRelatedStatus === PopupRelatedStatusEnum.CHOSEN_LEAVE) doLeave();
          /** 若用户快速重复点击返回按钮，取消重复的退出行为，只生效第1次点击 */
          if (this.backPopRelatedStatus === PopupRelatedStatusEnum.CHECKING_SHOW) return;

          this.showBackPop = await this.checkBackPopCanShow();

          if (this.showBackPop) {
            /** 强制打开挽留弹窗，同步状态到弹窗管理中心 */
            dialogHelper.applyOpenDialog(true, undefined, this.currentPageName);
            this.$ubtModuleExposeNew('finance_loan_preApplyChoose_backPop', { popupId: this.popupId });
            RouterHelper.useNextFalse(next);
          } else if (this.isDcHalfApply && !this.userHasJumpedCreditResult) {
            this.$ubtPageButton('finance_loan_credit_dchalfBack');
            this.$router.replace({
              path: RouterH5Enum.home,
              query: { source: 'credit_dchalf_back' },
            });

            next(false); // 阻止默认导航，由路由replace接管
          } else {
            /** 若挽留弹窗命中疲劳度，则继续导航 */
            doLeave();
          }
        } else {
          /** 其他情况继续导航 */
          doLeave();
        }
      }
    } else {
      // 非返回操作直接放行
      doLeave();
    }
  }

  /** 上报用户查看协议的停留时长状态 */
  private doReportUserStayStatus(scene: UserStayStatusSceneEnum) {
    const { extra, commoditys } = this.applyChooseList || {};

    reportUserStayStatus({
      scene,
      ...extra,
      commodityModelList: commoditys,
    });
  }

  /** 退出挽留弹窗本次访问-疲劳状态 */
  private backPopupOnceEnterTiredStatus = {
    [PopupIdEnum.PRE_APPLY_CHOOSE_LOADING_BACK]: false,
    [PopupIdEnum.PRE_APPLY_CHOOSE_CONTRACT_BACK]: false,
    [PopupIdEnum.PRE_APPLY_CHOOSE_LOAN_MARKET_HALF_BACK]: false,
  };

  /** 获取退出挽留弹窗ID */
  private get popupId() {
    /** 协议加载中 */
    if (this.showLoading) {
      return PopupIdEnum.PRE_APPLY_CHOOSE_LOADING_BACK;
    }

    /** 贷超半流程 */
    if (this.isDcHalfApply) {
      return PopupIdEnum.PRE_APPLY_CHOOSE_LOAN_MARKET_HALF_BACK;
    }

    /** 正常授信流程 */
    return PopupIdEnum.PRE_APPLY_CHOOSE_CONTRACT_BACK;
  }

  /** 检查退出挽留弹窗是否可展示 */
  private async checkBackPopCanShow() {
    const { popupId } = this;

    /** 若本次访问已疲劳，则不请求是否还有次数 */
    if (this.backPopupOnceEnterTiredStatus[popupId]) return false;

    try {
      this.backPopRelatedStatus = PopupRelatedStatusEnum.CHECKING_SHOW;
      const popupControl = await queryPopupFatigue(popupId);

      if (popupControl?.canShow) {
        this.backPopupOnceEnterTiredStatus[popupId] = true;
      }

      return popupControl?.canShow;
    } catch (error) {
      ubtSendError({
        name: `queryPopupFatigue-error-${popupId}`,
        message: (error as Error).message,
      });
      return false;
    } finally {
      this.backPopRelatedStatus = PopupRelatedStatusEnum.INIT;
    }
  }

  /**
   * 小程序场景，若需展示退出挽留弹窗，则需每次pushState一条记录，来实现拦截popstate事件
   */
  private oncePushStateForMpBackPopup() {
    /** 小程序链路返回时，拦截popstate事件 */
    if (platform.isWechatMini) {
      window.history.pushState({ forceIntercept: Date.now() }, '');
    }
  }

  /** 小程序链路返回时，拦截popstate事件 */
  private async handleFinanceMpPopState() {
    if (!platform.isWechatMini) {
      return;
    }
    if (this.backPopRelatedStatus === PopupRelatedStatusEnum.CHECKING_SHOW) {
      /** 非有效popstate消耗，补加1次popstate记录 */
      this.oncePushStateForMpBackPopup();
      return;
    }

    /**
     * 贷超半流程场景，不展示挽留弹窗
     * 分期商城场景不展示挽留弹窗
     * 活体验证(popup)场景中，无法展示挽留弹窗，所以不请求ad，避免无效消耗广告弹窗疲劳度
     */
    if (!this.isDcHalfApply && this.isRealInLoadCommodityDispatch && !this.showCreditFqmall) {
      this.showBackPop = await this.checkBackPopCanShow();

      if (this.showBackPop) {
        /** 每次展示挽留弹窗后，需添加1次popstate记录，来实现下一次的拦截popstate事件 */
        this.oncePushStateForMpBackPopup();
        /** 强制打开挽留弹窗，同步状态到弹窗管理中心 */
        dialogHelper.applyOpenDialog(true, undefined, this.currentPageName);
        this.$ubtModuleExposeNew('finance_loan_preApplyChoose_backPop');
      } else {
        miniProgramBackPreviousPage();
      }
    } else {
      /** 小程序链路无需展示弹窗时，调用bridge返回上一页 */
      miniProgramBackPreviousPage();
    }
  }

  private closeBackPop() {
    this.showBackPop = false;
    /** 关闭挽留弹窗，同步状态到弹窗管理中心 */
    dialogHelper.closeDialogNotify(200, this.currentPageName);
  }

  private handleLeavePage() {
    /** 用户点击“离开”，更新状态标识 */
    this.backPopRelatedStatus = PopupRelatedStatusEnum.CHOSEN_LEAVE;

    if (platform.isWechatMini) {
      miniProgramBackPreviousPage();
    } else {
      /**
       * 原逻辑在 beforeRouteLeave 中处理。
       * 半流程场景增加挽回弹框逻辑，挽回弹框点击放弃了，逻辑迁移至此处
       * */
      if (this.isDcHalfApply && !this.userHasJumpedCreditResult) {
        this.$ubtPageButton('finance_loan_credit_dchalfBack');
        this.$router.replace({
          path: RouterH5Enum.home,
          query: { source: 'credit_dchalf_back' },
        });

        return;
      }

      this.$router.go(-1);
    }
  }

  /**
   * 用户已提交了授信(跳结果页)，若back返回，则强制回到首页
   * 目前仅极小小流量的Andriod用户可以返回到授信分发页(此时页面保留跳出时的数据状态)
   * metis：https://metis2.hellobike.cn/browse/SKXDZC-8508
   * 原因猜测：禁用左侧退出 + history.go(-x)失效
   */
  private listenForceBackHomeFromCreditResult() {
    if (document.visibilityState === 'visible') {
      /** 小程序场景，若用户从授信结果页back返回，需在此读取session，并强制回退首页 */
      if (platform.isWechatMini && session.get(USER_HAS_JUMPED_OUT_PAGE_KEY)) {
        RouterHelper.setBackConfirm(false);
        miniProgramBackPreviousPage();
        return;
      }

      if (this.userHasJumpedCreditResult) {
        RouterHelper.setBackConfirm(false);
        RouterHelper.backHome();
      }
    }
  }

  private mounted() {
    document.addEventListener('visibilitychange', this.listenForceBackHomeFromCreditResult);
    window.addEventListener('popstate', this.handleFinanceMpPopState);
  }

  private beforeDestroy() {
    document.removeEventListener('visibilitychange', this.listenForceBackHomeFromCreditResult);
    window.removeEventListener('popstate', this.handleFinanceMpPopState);
    // 清除授信任务结果轮询定时器
    this.clearCreditTaskResultTimer();
  }

  // 获取流量分发渠道id列表
  private get commodityIdList() {
    return (this.applyChooseList?.commoditys || []).map((item) => item.commodityId || '');
  }

  /** 用户基本信息是否完整 */
  private get fillInTheInformation() {
    const { fillInTheInformation } = this.creditData || {};
    return fillInTheInformation === UserInfoStatus.Completed;
  }

  private async getMultiApplyChooseList(
    dispatchType?: PrefilterDispatchTypeEnum,
  ) {
    this.$nextTick(() => {
      setPageTitle('匹配产品');
    });

    return PreApplyChooseAPI.getMultiApplyChooseList(
      await getDeviceRiskData(),
      dispatchType,
      this.businessInfoextraData,
    );
  }

  private updateSubmitCreditApplyStore() {
    const commoditys = this.applyChooseList?.commoditys || [];
    /** 用户已选中渠道的id */
    const commodityIds = commoditys.map((item) => Number(item.commodityId));

    /** 更新授信订单提交的相关参数 */
    this.$updateState({
      submitCommodityIds: commodityIds,
      commodityModelList: commoditys.map((
        {
          commodityId, proApplyModel, abnormalProduct, followLoan, strategyAsset,
        },
      ) => (
        {
          commodityId, proApplyModel, abnormalProduct, followLoan, strategyAsset,
        })),
    });
  }

  /** 轻资产渠道-流量分发 */
  private async lightPrefilterDispatch(): Promise<boolean> {
    const getApplyChooseList = this.getMultiApplyChooseList.bind(this);
    /** 轻资产渠道分发 */
    const applyChooseList = await getApplyChooseList(
      PrefilterDispatchTypeEnum.LIGHT_DISPATCH,
    );

    this.$updateState({
      applyChooseList,
    });

    /** 前置判断：如果有战略轻资产渠道，则展示协议，不走资料补充逻辑 */
    const hasStrategyAsset = (applyChooseList?.commoditys || []).some(
      (item) => item?.strategyAsset === true,
    );
    if (hasStrategyAsset) {
      this.canShowContactList = true;
      return false;
    }

    /**
     * 协议是否展示状态重置
     * 有渠道 && 资料填写不全，则不展示协议，直接跳转资料补充页
     */
    if (this.commodityIdList.length && !this.fillInTheInformation) {
      this.canShowContactList = false;
      /** 先缓存授信订单提交参数，避免路由切换时，store数据清空 */
      const creditApplyParams = this.getSubmitCreditApplyParams(true);

      jumpToVerifyCredit(VerifySceneEnum.CREDIT_POST_SUPPLEMENT, {
        commodityIds: this.commodityIdList.map((item) => String(item)),
        useReplace: true,
        successCb: async () => {
          try {
            await creditAgreementsReadPop.open({
              commodityIdList: this.commodityIdList as number[],
            });

            const { taskId } = await PreApplyChooseAPI.applyMulty(creditApplyParams);

            this.goResult(taskId);
          } catch (error) {
            ubtSendError(error as Error);
          }
        },
      });

      return true;
    }

    this.canShowContactList = true;
    return false;
  }

  /**
   * 执行获取贷超半流程数据
   */
  private async fetchDcPrefilterData(): Promise<void> {
    try {
      const applyChooseList = await PreApplyChooseAPI.getDcPrefilter({
        scene: this.dcCreditScene,
        incompleteInfo: !this.fillInTheInformation,
      });
      this.$updateState({
        applyChooseList,
        isDcHalfApply: true,
      });
    } catch (err) {
      ubtSendError(err as Error);
    }
  }

  /**
   * 检查资料不完整用户的伽利略实验
   * @returns 是否命中实验组
   */
  private async checkIncompleteInfoExperiment(): Promise<boolean> {
    try {
      const { result } = await getGalileoAb().getAbResCatchError('202601041457351405', '202601041457351536');
      return result === ABResEnum.HINT;
    } catch (err) {
      ubtSendError(err as Error);
      return false;
    }
  }

  /**
   * 获取贷超半流程数据
   */
  private async getDcHalfApply(): Promise<void> {
    /**
     * 由于贷超列表限定在app内，所以半流程也需要限定在app内
     * 判断资料是否完整是由于半流程撞库需要拿用户信息进行前置判断并与将用户信息带到三方
     */
    // 已有商品ID，无需走半流程
    if (this.commodityIdList.length) {
      return;
    }

    // 不在哈啰app或者臻享花app内，埋点上报并返回
    if (!(platform.isEasyBike || platform.isSkzhenxhApp)) {
      this.$ubtPageButtonNew('finance_loan_credit_discontentDchalfPre', {
        /** 不通过原因：非app内 */
        reason: 0,
      });
      return;
    }

    // 资料完整，直接走半流程
    if (this.fillInTheInformation) {
      await this.fetchDcPrefilterData();
      return;
    }

    // 资料不完整，请求伽利略实验判断是否走半流程
    const isHitExperiment = await this.checkIncompleteInfoExperiment();
    if (isHitExperiment) {
      // 命中实验组，继续走半流程
      await this.fetchDcPrefilterData();
    } else {
      // 对照组，埋点上报
      this.$ubtPageButtonNew('finance_loan_credit_discontentDchalfPre', {
        /** 不通过原因：资料不完整 */
        reason: 1,
      });
    }
  }

  /**
   * 获取分期商城协议（失败重试3次）
   * @param retryCount 当前重试次数
   * @returns Promise<QueryContractListResponse | null>
   */
  private async getFqMallContract(retryCount = 0): Promise<QueryContractListResponse | undefined> {
    const maxRetries = 3;

    try {
      const result = await queryContractList({
        scene: CreditMallContractSceneEnum.CREDIT,
        from: CreditMallFromEnum.FINANCE_SCREENING_AGREEMENT,
        productId: this.fqProductList[0]?.productId,
      });
      this.fqMallContractList = result;
      return result || undefined;
    } catch (err) {
      const error = err as Error;
      // 如果还有重试次数，继续重试
      if (retryCount < maxRetries - 1) {
        return this.getFqMallContract(retryCount + 1);
      }
      // 最后一次重试失败才上报错误
      ubtSendError(error);
      return undefined;
    }
  }

  /**
   * 活体后流量分发逻辑
   * @param {boolean} needNormalDistribution 是否需要正常授信分流(自营&联营导流渠道分流)
   * 纯半流程授信场景不需要正常授信分流
  */
  private async getPeApplyChooseList(needNormalDistribution = true) {
    this.isRealInLoadCommodityDispatch = true;

    let applyChooseList;
    // 活体认证通过后，获取当前的可授信渠道列表
    try {
      /** 避免因风控、服务返回 非0异常，停留在loading状态 */
      const getApplyChooseList = this.getMultiApplyChooseList.bind(this);
      /** 防止特殊场景多次请求分流接口, 协议不更新问题 */
      this.$updateState({
        applyChooseList: null,
      });

      if (needNormalDistribution) {
        applyChooseList = await getApplyChooseList(
          this.ocrAfterLoan
            ? PrefilterDispatchTypeEnum.DIRECT_8180 : undefined,
        );
        // 是否命中正常授信流程协议展示前置校验跳转逻辑
        await this.preCheckWithShowAgreements(applyChooseList);

        this.$updateState({
          applyChooseList,
        });

        if (this.ocrAfterLoan) {
          let isAutarkyCreditSuccess;
          /** 自营初筛通过，则静默提交授信订单 */
          if (this.commodityIdList.length) {
            this.canShowContactList = false;

            const creditApplyParams = this.getSubmitCreditApplyParams(true);
            const { taskId } = await PreApplyChooseAPI.applyMulty(creditApplyParams);

            isAutarkyCreditSuccess = await this.loopQueryCreditTaskResult(taskId);
            /** 若授信审核成功，则终止后续流程 */
            if (isAutarkyCreditSuccess) return;
          }

          if (applyChooseList?.continueLightDispatch || isAutarkyCreditSuccess === false) {
            const isJumpedVerifyCredit = await this.lightPrefilterDispatch();
            /** 若已跳转资料补充页，则终止后续流程 */
            if (isJumpedVerifyCredit) return;
          }
        }
      }


      /** 如果是中收场景，只展示贷超半流程相关的逻辑，不走分期商城流程 */
      if (!this.isOnlyDcHalf) {
      // 分期商城流程请求
        const fqMallReviewResult = await handleFqMallReviewFlow({
          isEasyBike: platform.isEasyBike,
          commodityIdList: this.commodityIdList,
          router: this.$router,
          from: this.from,
        });

        // 如果已跳转，直接返回
        if (fqMallReviewResult === undefined) {
          return;
        }

        const { showResult: fqMallShowResult, productList } = fqMallReviewResult;
        this.fqProductList = productList || [];

        // 统一处理获取数据逻辑：准入情况下同时获取协议和贷超数据，否则只获取贷超数据
        if (fqMallShowResult) {
        // 准入情况下，同时获取分期商城协议和贷超半流程数据
          await Promise.allSettled([
            this.getFqMallContract(),
            this.getDcHalfApply(),
          ]);

          // 处理结果：只有成功获取到协议数据才算准入成功
          if (this.fqMallContractList?.contractList?.length) {
          // 成功获取到协议数据，才算准入成功
            this.showCreditFqmall = true;
            // 如果准入成功，则直接返回 不执行后续逻辑
            return;
          }
        } else {
        // 未准入或非分期商城流程，只获取贷超半流程数据
          await this.getDcHalfApply();
        }
      } else {
        await this.getDcHalfApply();
      }

      // 正常授信流程/贷超半流程授信有渠道返回
      if (this.commodityIdList.length) {
        await checkAndHandleLocationPermission();
      } else {
        /** 记录小程序已跳出授信分发页，用于back回退兼容小程序 */
        session.set(USER_HAS_JUMPED_OUT_PAGE_KEY, 1);
        let middleIncomeLink: string | undefined;
        if (!this.isOnlyDcHalf) {
          // 获取中收变现外跳链接
          middleIncomeLink = await getMiddleIncomeLink();
        }
        chooseNoChannelRouter(middleIncomeLink);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('getPeApplyChooseList error', error);
      if (isAbortXhr(error)) {
        throw error;
      }
      // TODO: 先加异常埋点，后续根据埋点统计数据与确认此处用户漏损是否需要跳转贷超
      this.$ubtPageButtonNew('finance_loan_credit_prefilterFail', {
        error: JSON.stringify(error),
      });

      /** 修复当用户已提交授信订单，有taskId时，还Toast提示授信失败 */
      if (!(applyChooseList && applyChooseList.taskId)) {
        Toast('授信失败');
      }
    }
  }

  // 初筛初始化数据
  private getPreApplyInfo() {
    /** 若是ocr后置提现流程，则跳过活体验证，因前置已检验过活体 */
    if (this.ocrAfterLoan) {
      this.getPeApplyChooseList();
    } else {
      // 进入页面校验活体
      livenessPop
        .ensureLiveness(
          this,
          {
            func: () => PreApplyChooseAPI.checkocr().finally(() => {
              Loading.clearAll();
            }),
            failed: () => {
            // TODO: 先加异常埋点，后续根据埋点统计数据与确认此处用户漏损如何处理
              this.$ubtPageButton('finance_loan_credit_preLivenessFail');
              RouterHelper.setBackConfirm(false);

              if (this.myProfileChoose) {
                this.$router.go(-1);
              } else {
                RouterHelper.backHome();
              }
            },
            param: {
              project: LivenessProjectEnum.ZYQ,
              scene: LivenessSceneEnum.Authority,
            },
          },
        )
        .then(() => {
          this.getPeApplyChooseList();
        })
        .catch((error: Error) => {
          if (error && !error.message) {
            this.$router.replace({
              path: RouterV2Enum.preApplyFailed,
              query: {
                from: RouterV2Enum.preApplyChoose,
              },
            });
          }
        });
    }
  }

  private async onSubmit() {
    await livenessPop.ensureLiveness(
      this,
      {
        func: async () => {
          // 贷超半流程授信
          if (this.isDcHalfApply) {
            const { applyMode } = this.applyChooseList || {};
            PreApplyChooseAPI.dcCreditApply({
              commodityList: this.submitCommodityIds,
              scene: this.dcCreditScene,
              applyMode,
              incompleteInfo: !this.fillInTheInformation,
            })
              .then(async ({ taskId }) => {
                // 增加超级会员下单流程，详见需求：https://metis2.hellobike.cn/team/detail/issue?filterId=3846&openDetail=665639&teamId=198
                await this.checkSatusAndBuyRight(taskId);

                const source = this.isDcPreApplyChoose ? 'dcPreApplyChoose' : 'dcCredit';
                /** 设置已进入授信结果的标志，用于back回退兼容哈啰Andriod、小程序 */
                this.userHasJumpedCreditResult = true;
                session.set(USER_HAS_JUMPED_OUT_PAGE_KEY, 1);

                jumpToNewVersion(NewVersionEnum.HALF_PROCESS_RESULT, true, `taskId=${taskId}&needCustomGoBack=true&source=${source}`);
              });
            return;
          }

          /* todo，授信同意协议以后，是否需要展示补充职业资料模块，还是跳转后面流程，通过 getinfo 接口，
          返回新字段，前端来处理。
          exitUserBaseInfo 有值,则check，无值，则不 check
          */
          const personInfo = await UserPersonalInfoApi.getPersonalInfo();
          const { exitUserBaseInfo } = personInfo || {};
          if (exitUserBaseInfo) {
            await this.checkSupplyNeed(this.submitCommodityIds as unknown as string[]);
          }

          // 只有在自营用户初始化时，才展示弹窗
          if (this.autarkyState
              && this.autarkyState.autarky
              && this.autarkyState.autarkyUpgradeState === UpgradeStateEnum.INIT) {
            localStorage.setItem(upgradeUserInfosKey, JSON.stringify({
              // 进入臻有钱首页时是否展示升级 Toast 提示
              needToast: true,
            }));
          }

          await this.goPreApply();
        },
        failed: () => {
          // TODO: 先加异常埋点，后续根据埋点统计数据与确认此处用户漏损如何处理
          this.$ubtPageButton('finance_loan_credit_submitLivenessFail');
          Toast('人脸识别错误 ！');
          RouterHelper.setBackConfirm(false);
          RouterHelper.backHome();
        },
        param: {
          project: LivenessProjectEnum.ZYQ,
          scene: LivenessSceneEnum.Authority,
        },
      },
    );
  }

  private getSubmitCreditApplyParams(shouldUpdateStore = false) {
    if (shouldUpdateStore) {
      /** 先更新前置授信订单提交的store */
      this.updateSubmitCreditApplyStore();
    }

    /**
     * TODO: 后续需与后端优化此处：透传的参数filterType, applyMode, dispatchBatchNo, autarky都放extra对象中
     * 本次由于后端改动太多，所以上述参数后端暂不处理
     */
    const {
      filterType, applyMode, dispatchBatchNo, autarky, extra,
    } = this.applyChooseList || {};

    return {
      commodityList: this.submitCommodityIds,
      commodityModelList: this.commodityModelList,
      applyType: filterType,
      applyMode,
      dispatchBatchNo,
      extra,
      autarky,
      creditRouteChannel: this.creditRouteChannel,
    };
  }

  /** 授信申请接口 99线 3000多ms，先加个1000ms，看看是否有缓解 */
  /**
   * 判断是否满足战略轻资产跳转结果页的条件
   * 判断条件：并行有战略轻资产 || 非并行战略轻资产在首位
   * @returns 是否满足条件
   */
  private shouldGoToResultByStrategy(): boolean {
    const hasStrategyAsset = this.commodityModelList.some(
      (item) => item?.strategyAsset === true,
    );
    const { applyMode } = this.applyChooseList || {};
    const firstIsStrategyAsset = this.commodityModelList[0]?.strategyAsset === true;

    return (applyMode === ApplyModeEnum.parallel && hasStrategyAsset)
      || (applyMode !== ApplyModeEnum.parallel && firstIsStrategyAsset);
  }

  @Debounce(1000)
  private async goPreApply(applyTaskParams?: CreditApplyTaskType) {
    Loading.trigger(true);

    await PreApplyChooseAPI.applyMulty(applyTaskParams || this.getSubmitCreditApplyParams())
      .then(async (data) => {
        const jumpToCreditPostSupplement = async (scene: VerifySceneEnum) => {
          /** 极简流程下单 */
          await this.checkSatusAndBuyRight(data.taskId);

          jumpToVerifyCredit(scene, {
            commodityIds: this.submitCommodityIds,
            creditId: data.taskId,
            useReplace: true,
          });
        };

        /**
         * 极简流程
         * 1. 若首位是自营(非ocr后置流程)，已发起自营授信任务，跳转授信结果页，查看自营渠道审核进度，此时轻资产是挂起状态
         * 2. 若首位是自营(ocr后置流程)，先补充ocr之后，再发起自营授信任务
         * 3. 若首位是轻资产，优先补充资料完整后，发起授信任务
         */
        if (this.submitCommodityIds.indexOf(8180) === 0) {
          if (this.commodityModelList[0].followLoan === true) {
            this.goResult(data.taskId);
          } else if (!await isVerifyCreditComplete(VerifySceneEnum.CREDIT_MIDDLE_ONLY_OCR)) {
            jumpToCreditPostSupplement(VerifySceneEnum.CREDIT_MIDDLE_ONLY_OCR);
          } else {
            this.goResult(data.taskId);
          }
        } else if (this.shouldGoToResultByStrategy()) {
          this.goResult(data.taskId);
        } else if (!this.fillInTheInformation) {
          /** 轻资产授信，资料不完整，则跳转补充资料页面 */
          jumpToCreditPostSupplement(VerifySceneEnum.CREDIT_POST_SUPPLEMENT);
        } else {
          this.goResult(data.taskId);
        }
      });

    Loading.clearAll();
  }

  /**
   * 轮询调用 getCreditTaskResult结果
   * 若是 SUCCEEDED 调用 goResult
   * @returns Promise<CreditTaskResultType> 轮询过程中保持 pending 状态，直到返回非submitting态
   */
  private loopQueryCreditTaskResult(taskId: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const poll = async () => {
        try {
          const result = await PreApplyChooseAPI.getCreditTaskResult(taskId);

          if (result.taskStatus === CreditTaskStatusEnum.SUBMITTING) {
            /** 1秒后继续轮询，Promise保持pending状态 */
            this.creditTaskResultTimer = setTimeout(poll, 1000);
          } else {
            this.creditTaskResultTimer = null;
            /** 若授信审核通过，则跳转-授信结果页，并终止轮询 */
            if (result.taskStatus === CreditTaskStatusEnum.SUCCEEDED) {
              this.goResult(taskId);
              resolve(true);
            }

            resolve(false);
          }
        } catch (error) {
          // 发生错误时清除定时器并 reject Promise
          this.creditTaskResultTimer = null;
          ubtSendError({
            name: 'waitCreditTaskResult-error',
            message: (error as Error).message,
          });
          resolve(false);
        }
      };

      // 开始轮询
      poll();
    });
  }

  /**
   * 清除授信任务结果轮询定时器
   */
  private clearCreditTaskResultTimer(): void {
    if (this.creditTaskResultTimer) {
      clearTimeout(this.creditTaskResultTimer);
      this.creditTaskResultTimer = null;
    }
  }

  // 协议加载完成后关闭loading
  private onLoadAgreements() {
    this.showLoading = false;

    /** 若用户在协议加载中展示挽留弹窗未关闭，则协议加载完成后强制关闭挽留弹窗 */
    this.closeBackPop();

    setPageTitle('');
  }

  private renderBackPop() {
    /** 协议加载阶段使用 LoadingBackPop，协议展示阶段使用 ContractBackPop */
    const DynicComponent = (this.showLoading ? LoadingBackPop : ContractBackPop) as VueConstructor;

    return (
      <DynicComponent
        show={this.showBackPop}
        needSupplement={!this.fillInTheInformation}
        popupId={this.popupId}
        onClose={this.closeBackPop.bind(this)}
        onConfirm={this.closeBackPop.bind(this)}
        onCancel={this.handleLeavePage.bind(this)}
      />
    );
  }

  private render() {
    /**  特殊注意⚠️
     * ConsentAgreement 新版本协议页面
     * 现状：所有渠道均使用新版协议页面，后续考虑直接删除老版页面的判断逻辑
     *
     * */
    return (
      <div class={style.all}>
        {this.getUpdatedIdentityPhotoDialog()}
        {this.showLoading && <LoadingAnimateComp ref="loadingAnimateRef" staticLoadingStyle={this.ocrAfterLoan} />}
        {this.showCreditFqmall && (
          <UnitAgreement
            showLoading={this.showLoading}
            dcCreditScene={this.dcCreditScene}
            productList={this.fqProductList}
            fqMallContractList={this.fqMallContractList}
            from={this.from || ''}
            onLoadAgreements={this.onLoadAgreements.bind(this)}
          />
        )}
        {!this.showCreditFqmall && this.commodityIdList.length > 0 && this.canShowContactList && (
          <ConsentAgreement
            isOnlyDcHalf={this.isOnlyDcHalf}
            userViewAgreementStartTime={this.userViewAgreementStartTime}
            onLoadAgreements={this.onLoadAgreements.bind(this)}
            onSubmit={this.onSubmit.bind(this)}
            onReportUserStayStatus={this.doReportUserStayStatus.bind(this)}
            onSetUserViewAgreementStartTime={this.setUserViewAgreementStartTime.bind(this)}
          />
        )}
        <ProfessionPicker
          v-model={this.professionPickerPop}
          needSupplyCommodityIds={this.needSupplyCommodityIds}
          onConfirm={this.goPreApply.bind(this)}
          onClose={() => { this.professionPickerPop = false; }}
        />
        {this.renderBackPop()}
      </div>
    );
  }
}
